import React from 'react';
import { texts } from './languages/fr';
import { Link } from '@mui/material';

const CustomTunnelStep = React.lazy(() =>
    import('containers/tunnel/steps/custom-step/CustomTunnelStep')
);
const AccountCreation = React.lazy(() =>
    import('containers/tunnel/steps/account-creation/AccountCreation')
);
const DistributorPedagogicStep = React.lazy(() =>
    import('containers/tunnel/onboarding/DistributorPedagogicStep')
);
const ContactInfo = React.lazy(() => import('containers/tunnel/steps/contact-info/ContactInfo'));
const CoSubscriber = React.lazy(() => import('containers/tunnel/steps/co-subscriber/CoSubscriber'));
const KYCSurvey = React.lazy(() => import('containers/tunnel/steps/kyc-survey/KYCSurvey'));
const InvestmentCharacteristics = React.lazy(() =>
    import('containers/tunnel/steps/InvestmentCharacteristics')
);
const IDCheck = React.lazy(() => import('containers/tunnel/steps/IDCheck'));
const SecondIDCheck = React.lazy(() => import('containers/tunnel/steps/SecondIDCheck'));
const AddressCheck = React.lazy(() => import('containers/tunnel/steps/AddressCheck'));
const RIBCheck = React.lazy(() => import('containers/tunnel/steps/RIBCheck'));
const FundRegulations = React.lazy(() => import('containers/tunnel/steps/FundRegulations'));
const DICI = React.lazy(() => import('containers/tunnel/steps/DICI'));
const DirectDebitAuthorization = React.lazy(() =>
    import('containers/tunnel/steps/DirectDebitAuthorization')
);
const SubscriptionFormSignature = React.lazy(() =>
    import('containers/tunnel/steps/subscription-form/SubscriptionForm')
);
const KBIS = React.lazy(() => import('containers/tunnel/steps/KBIS'));
const Statuts = React.lazy(() => import('containers/tunnel/steps/Statuts'));
const VigilanceInvestor = React.lazy(() =>
    import('containers/tunnel/steps/laundering-form/VigilanceInvestor')
);
const VigilanceOwner = React.lazy(() =>
    import('containers/tunnel/steps/laundering-form/VigilanceOwner')
);
const AutoCertification = React.lazy(() => import('containers/tunnel/steps/AutoCertification'));
const DistributorDocuments = React.lazy(() =>
    import('containers/tunnel/onboarding/DistributorDocuments')
);
const DistributorKYC = React.lazy(() => import('containers/tunnel/onboarding/DistributorKYC'));
const KYCPedagogicStep = React.lazy(() => import('containers/tunnel/steps/KYCPedagogicStep'));
const LastStepOnboarding = React.lazy(() =>
    import('containers/tunnel/onboarding/LastStepOnboarding')
);
const Eligibility = React.lazy(() => import('containers/tunnel/steps/eligibility/Eligibility'));
const UserKnowledge = React.lazy(() => import('containers/tunnel/steps/UserKnowledge'));
const Experience = React.lazy(() => import('containers/tunnel/steps/experience/ExperienceStep'));
const UserAdequacy = React.lazy(() => import('containers/tunnel/steps/UserAdequacy'));
const SurveyResults = React.lazy(() => import('containers/tunnel/steps/SurveyResults'));
const RegulatoryDocuments = React.lazy(() => import('containers/tunnel/steps/RegulatoryDocuments'));
const PerformancePedagogicStep = React.lazy(() =>
    import('containers/tunnel/steps/PerformancePedagogicStep')
);
const IdUpload = React.lazy(() => import('containers/tunnel/steps/IdUpload'));

export const userChallenges = {
    NEW_PASSWORD_REQUIRED: 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
    SMS_CODE_REQUIRED: 'CONFIRM_SIGN_IN_WITH_SMS_CODE',
};

export const PASS_REGEX = /^(?=.{8,}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[\W_])(?!.*\s).*$/;
export const NAME_REGEX = /^[^0-9_!¡?¿/+=@#$%ˆ&*(){}|~<>;:,[\]]+$/;
export const COMPANY_NAME_REGEX = /^(?=.*\p{L})(?=.*\p{L}.*\p{L}).+$/u;
export const EURO_SYMBOL = '\xa0\u20AC';
export const PARANTHESES_EURO_SYMBOL = '\xa0(\u20AC)';
export const iFrameKey = 'tunnel-iframe';

export const CognitoErrors = {
    USERNAME_EXISTS: 'UsernameExistsException',
    CODE_MISMATCH: 'CodeMismatchException',
    CODE_EXPIRED: 'ExpiredCodeException',
    NO_USER: 'No current user',
};

// this list must currently be updated every time there are changes in the DB
export const RoleNames = {
    SERVICER_ADMIN: 'Administrateur servicer',
    SERVICER_SIGNATORY: 'Signataire servicer',
    SERVICER_STANDARD: 'Standard servicer',
    PROVIDER_ADMIN: 'Administrateur provider',
    PROVIDER_SIGNATORY: 'Signataire provider',
    PROVIDER_STANDARD: 'Standard provider',
    ADMIN_CIF: 'Admin CIF',
    PSI: "Prestataire de Services d'Investissements",
    COMMERCIALISATEUR: 'CIF',
    PP_PROFESSIONNEL: 'PP Professionnel',
    PM_PROFESSIONNEL: 'PM Professionnel',
    NETWORK_ADMIN: 'Network Admin',
    PROMOTER_ADMIN: 'Administrateur promoter',
    PROMOTER_STANDARD: 'Standard promoter',
};

export const UserEnrichments = {
    ALERTS: 'alerts',
    BANKING_STATEMENT: 'bankingStatement',
    COMMENTS: 'comments',
    COMPANY: 'investorCompany',
    CREATED_BY: 'createdBy',
    DISTRIBUTOR_COMPANY: 'distributorCompany',
    DOCUMENTS: 'documents',
    INTERNAL_RATE_OF_RETURN: 'internalRateOfReturn',
    INVESTMENT_CHARACTERISTICS: 'investmentCharacteristics',
    INVESTMENT_FUND: 'investmentFund',
    INVESTOR_PROFILE: 'investorProfile',
    KYC_SURVEY: 'kycSurvey',
    NETWORKS: 'networks',
    NOTIFICATIONS: 'notifications',
    PAYMENTS: 'payments',
    ROLES: 'roles',
    SHARE_CATEGORY: 'shareCategory',
    SHARE_SUBCATEGORY: 'shareSubcategory',
    SIGNATURES: 'signatures',
    SUBSCRIPTIONS: 'subscriptions',
    USER_ADEQUACY: 'userAdequacy',
    USER_KNOWLEDGE: 'userKnowledge',
    USER_TUNNEL_STEPS: 'userTunnelSteps',
    SGP: 'sgp',
    PROMOTER: 'promoter',
};

export const DistributorEnrichments = {
    NETWORK: 'network',
    PROMOTERS: 'promoters',
};

export const InternalErrors = {
    USERNAME_EXISTS: 'user.username_exists',
    NETWORK_NAME_EXISTS: 'name: network.name.exists',
    NETWORK_ASSIGN_MISMATCH: 'distributorCompanies: network.distributor_company.already_assigned',
    EMAIL_EXISTS: 'user.email: email_already_used',
    EMAIL_EXISTS_2: 'email: email_already_used',
    USER_ROLE_VIOLATION: 'The new role is different from the existing role.',
    ONGOING_SUBSCRIPTION_VIOLATION: 'subscription.in_progress',
    SHARE_CATEGORY_NOT_FOUND: 'share_category.not_found',
    CATEGORY_UNAVAILABLE: 'category unavailable',
};

export const investorRoles = [RoleNames.PP_PROFESSIONNEL, RoleNames.PM_PROFESSIONNEL];

export const servicerRoles = [
    RoleNames.SERVICER_ADMIN,
    RoleNames.SERVICER_SIGNATORY,
    RoleNames.SERVICER_STANDARD,
    RoleNames.NETWORK_ADMIN,
];

export const providerRoles = [
    RoleNames.PROVIDER_ADMIN,
    RoleNames.PROVIDER_SIGNATORY,
    RoleNames.PROVIDER_STANDARD,
];

export const promoterRoles = [RoleNames.PROMOTER_ADMIN, RoleNames.PROMOTER_STANDARD];

export const roleCategories = {
    SERVICERS: 'Servicers',
    PROVIDERS: 'Providers',
    PROMOTERS: 'Promoters',
    INVESTORS: 'Investors',
    DISTRIBUTORS: 'Distributors',
    ADMIN_DISTRIBUTORS: 'Admin Distributors',
};

// investment fund names as saved in the DB
export const investmentFunds = {
    BEX_IV: 'BEX Fund IV by Peqan',
    BEX_V: 'BEX Fund V by Peqan',
    PEQAN_CO: 'Peqan Co-Investissement 2022',
    EU_BUY_OUT: 'European buy-out opportunities 2022',
    QUAD: 'Quadrille Technologies V by Peqan',
    LATOUR: 'Latour Capital IV by Peqan',
    APAX: 'Apax Development Fund II by Peqan',
    CLUB_DEAL_1: 'PEQAN SINGLE ASSET 1',
    CLUB_DEAL_2: 'PEQAN SINGLE ASSET 2',
    ETI: 'Eiffel Transition Infrastructure by Peqan',
    CAPENERGIE: 'Capenergie 5 Private Investors',
    CICLAD: 'Ciclad 7 Private Investors',
};

export const fundTypes = {
    FCPR: 'FCPR',
    FPCI: 'FPCI',
    SLP: 'SLP',
    FPS: 'FPS',
};

export const subscriptionStatus = {
    IN_PROGRESS: 'in_progress',
    PENDING_PAYMENT: 'pending_payment',
    FINISHED: 'finished',
};

export const subscriptionStatusLabels = {
    [subscriptionStatus.IN_PROGRESS]: texts.ONGOING_2,
    [subscriptionStatus.FINISHED]: texts.COMPLETED_2,
};

export const userAvailabilityStatus = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    PENDING_PASSWORD_CHANGE: 'pending_password_change',
};

export const cognitoCustomAttributes = {
    ROLE: 'custom:role',
    ROLE_ID: 'custom:role_id',
    FUND_ID: 'custom:fund_id',
    FUND_NAME: 'custom:fund_name',
    USER_TITLE: 'custom:user_title',
    SGP_NAME: 'custom:sgp_name',
    SGP_LOGO: 'custom:sgp_logo',
    PROMOTER_LOGO: 'custom:promoter_logo',
};

export const stepStatus = {
    FAILED: 'verificationFailed',
    VERIFIED: 'verified',
    COMPLETED: 'completed',
    INCOMPLETE: 'incomplete',
    SIGNED_BY_INVESTOR: 'investor_signed_bs',
    SIGNED_BY_COSUBSCRIBER: 'cosubscriber_signed_bs',
    VALIDATED_BY_SERVICER: 'servicer_validated_bs',
    VALIDATED_BY_CIF: 'cif_validated_bs',
    PAYMENT_CONFIRMED: 'payment_confirmed',
    SIGNED_BY_SGP: 'sgp_signed_bs',
};

export const billStatus = {
    CREATED: 'created',
    COMPLETED: 'completed',
    ACTIVATED: 'activated',
};

export const conventionStatus = {
    NOT_SIGNED: 'not_signed',
    SIGNATURE_REQUESTED: 'signature_requested',
    PARTIALLY_SIGNED: 'partially_signed',
    FULLY_SIGNED: 'fully_signed',
    REFUSED: 'refused',
    REQUESTED_DISTRIBUTOR: 'requested_distributor',
};

export const validationStatus = {
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    NOT_VALIDATED: 'not_validated',
};

export const paymentStatus = {
    CREATED: 'created',
    PENDING_CONFIRMATION: 'pending_confirmation',
    CONFIRMED: 'confirmed',
    FAILED: 'failed',
};

export const capitalCallStatus = {
    CREATED: 'created',
    ACTIVATED: 'activated',
    COMPLETED: 'completed',
};

export const investorErrors = {
    SUM_INVALID: 'investing_sum.invalid',
    INVESTMENT_SERVICE_PROVIDER: 'investor_eligibility.investment_service_provider',
    ELIGIBILITY_INVALID: 'investor_eligibility.invalid_input',
    ELIGIBILITY_INITIAL_INVALID: 'investor_eligibility.initial_subscription.invalid_input',
    STEP_SYNTAX_ERROR: 'step.syntax.invalid_input',
    BUSINESS_FAILED: 'step.business.failed',
    IS_US_PERSON: 'step.contact_info.failed',
    INVALID_OPTION: 'invalid.option',
    INVALID_PHONE: 'phone_number.invalid',
    INVALID_NIF: 'investor.nif_digits_number',
    CO_SUBSCRIBER_INVALID_NIF: 'co_subscriber.nif.digits_number',
    INVALID_IBAN: 'iban_not_valid',
    EXPERIENCE_SCORING_FAILED: 'experience.scoring_failed',
    INVALID_PHONE_NUMBER: 'invalid_phone_number',
    CONTACT_INFO_US_PERSON: 'contact_info_us_person',
    SUBSCRIPTION_IN_PROGRESS: 'subscription.in_progress',
    FIRST_NAME_ILLEGAL_CHARACTER: 'user.firstName: illegal_character',
    LAST_NAME_ILLEGAL_CHARACTER: 'user.lastName: illegal_character',
    ALREADY_ACTIVE: 'user.already_active',
};

export const ribErrors = {
    INVALID_IBAN: 'iban_not_valid',
    INVALID_RESPONSE_STATUS: 'status_code_not_valid',
    INVALID_BIC: 'bic_not_valid',
    EMPTY_BIC: 'bic_empty',
    BIC_INVALID: 'bic_invalid',
    DIRECT_DEBIT_NOT_ALLOWED: 'payment_method.direct_debit.not_allowed',
};

const { COMPLETED, VERIFIED, FAILED } = stepStatus;

export const directDebitAllowedCountries = [
    'DE',
    'AT',
    'BE',
    'BG',
    'CY',
    'HR',
    'DK',
    'ES',
    'EE',
    'FI',
    'FR',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'CZ',
    'RO',
    'SK',
    'SI',
    'SE',
    'IS',
    'LI',
    'NO',
    'GB',
    'CH',
    'AD',
    'MC',
    'MF',
    'VA',
];

export const stepIDs = {
    ACCOUNT_CREATION: 2,
    CONTACT_INFO: 3,
    KYC_SURVEY: 8,
    ID_CHECK: 12,
    SECOND_ID_CHECK: 21,
    ADDRESS_CHECK: 13,
    RIB_CHECK: 14,
    FUND_REGULATIONS: 15,
    DICI: 16,
    VIGILANCE_INVESTOR: 24,
    VIGILANCE_OWNER: 28,
    DIRECT_DEBIT_AUTHORIZATION_SIGNATURE: 17,
    SUBSCRIPTION_FORM_SIGNATURE: 18,
    KBIS: 22,
    STATUTS: 23,
    AUTO_CERTIFICATION: 29,
    DISTRIBUTOR_DOCUMENTS: 32,
    LAST_STEP_ONBOARDING: 19,
    KYC_PEDAGOGIC_STEP: 33,
    ELIGIBILITY: 34,
    USER_KNOWLEDGE: 35,
    EXPERIENCE: 36,
    USER_ADEQUACY: 37,
    SURVEY_RESULTS: 38,
    REGULATORY_DOCUMENTS: 39,
    PERFORMANCE: 40,
    INVESTMENT_CHARACTERISTICS: 41,
    ID_UPLOAD: 44,
    PREFERENCES: 45,
    CO_SUBSCRIBER_CONTACT_INFO: 46,
    CO_SUBSCRIBER_ID_CHECK: 47,
    CUSTOM_STEP: 49,
};

export const stepNames = {
    2: texts.ACCOUNT_CREATION,
    3: texts.COORDONNEES,
    8: texts.KYC_SURVEY,
    12: texts.ID_CHECK,
    13: texts.ADDRESS_CHECK,
    14: texts.BANK_AND_FISCAL_INFO,
    15: texts.FUND_REGULATIONS,
    16: texts.DICI,
    17: texts.DIRECT_DEBIT_AUTHORIZATION,
    18: texts.SUBSCRIPTION_FORM_SIGNATURE,
    19: texts.LAST_STEP_ONBOARDING,
    21: texts.SECOND_ID_CHECK,
    22: texts.KBIS,
    23: texts.STATUTS,
    24: texts.VIGILANCE_INVESTOR,
    28: texts.VIGILANCE_OWNER,
    29: texts.AUTO_CERTIFICATION,
    32: texts.DISTRIBUTOR_DOCUMENTS_TITLE,
    33: texts.KYC_PEDAGOGIC_STEP,
    34: texts.ELIGIBILITY,
    35: texts.USER_KNOWLEDGE,
    36: texts.EXPERIENCE,
    37: texts.YOUR_INVESTOR_PROFILE,
    38: texts.SURVEY_RESULTS,
    39: texts.DOCUMENTS_REGLEMENTAIRES,
    40: texts.PERFORMANCE,
    41: texts.INVESTEMENT_CHARACTERISTICS,
    44: texts.ID_UPLOAD,
    46: texts.CO_SUBSCRIBER_CONTACT_INFO,
    47: texts.CO_SUBSCRIBER_ID_UPLOAD,
    49: '',
};

export const TUNNEL_STEPS = [
    { stepId: 2, component: AccountCreation, allowNext: [VERIFIED] },
    { stepId: 3, component: ContactInfo, allowNext: [VERIFIED] },
    { stepId: 8, component: KYCSurvey, allowNext: [VERIFIED] },
    { stepId: 12, component: IDCheck, allowNext: [VERIFIED, COMPLETED, FAILED] },
    { stepId: 13, component: AddressCheck, allowNext: [VERIFIED, COMPLETED, FAILED] },
    { stepId: 14, component: RIBCheck, allowNext: [VERIFIED] },
    { stepId: 15, component: FundRegulations, allowNext: [VERIFIED] },
    { stepId: 16, component: DICI, allowNext: [VERIFIED] },
    { stepId: 17, component: DirectDebitAuthorization, allowNext: [VERIFIED, COMPLETED] },
    { stepId: 18, component: SubscriptionFormSignature, allowNext: [VERIFIED, COMPLETED] },
    { stepId: 19, component: LastStepOnboarding, allowNext: [] },
    { stepId: 21, component: SecondIDCheck, allowNext: Object.values(stepStatus) },
    { stepId: 22, component: KBIS, allowNext: [VERIFIED] },
    { stepId: 23, component: Statuts, allowNext: [VERIFIED] },
    { stepId: 24, component: VigilanceInvestor, allowNext: [VERIFIED] },
    { stepId: 28, component: VigilanceOwner, allowNext: [VERIFIED] },
    { stepId: 29, component: AutoCertification, allowNext: [VERIFIED] },
    { stepId: 32, component: DistributorDocuments, allowNext: [VERIFIED] },
    { stepId: 33, component: KYCPedagogicStep, allowNext: [VERIFIED] },
    { stepId: 34, component: Eligibility, allowNext: [VERIFIED] },
    { stepId: 35, component: UserKnowledge, allowNext: [VERIFIED] },
    { stepId: 36, component: Experience, allowNext: [VERIFIED] },
    { stepId: 37, component: UserAdequacy, allowNext: [VERIFIED] },
    { stepId: 38, component: SurveyResults, allowNext: [VERIFIED] },
    { stepId: 39, component: RegulatoryDocuments, allowNext: [VERIFIED] },
    { stepId: 40, component: PerformancePedagogicStep, allowNext: [VERIFIED] },
    { stepId: 41, component: InvestmentCharacteristics, allowNext: [VERIFIED] },
    { stepId: 42, component: DistributorKYC, allowNext: [VERIFIED] },
    { stepId: 44, component: IdUpload, allowNext: [VERIFIED] },
    { stepId: 46, component: CoSubscriber, allowNext: [VERIFIED] },
    { stepId: 47, component: IdUpload, allowNext: [VERIFIED] },
    { stepId: 48, component: DistributorPedagogicStep, allowNext: [VERIFIED] },
    { stepId: 49, component: CustomTunnelStep, allowNext: [VERIFIED] }, // special tunnel step object
];

export const queryStringifyOptions = {
    arrayFormat: 'bracket',
    skipEmptyString: true,
    skipNull: true,
};

export const DOCUMENT_TYPES = [
    { key: 'tel-bill', type: 'PB', name: 'Facture de téléphone ou Internet' },
    { key: 'gas-bill', type: 'UB', name: "Facture d'électricité ou de gaz" },
    { key: 'lease-bill', type: 'LAG', name: 'Quittance de loyer' },
    { key: 'water-bill', type: 'UB', name: "Facture d'eau" },
    { key: 'tax-bill', type: 'TR', name: "Avis d'imposition ou certificat de non-imposition" },
    { key: 'council-bill', type: 'CB', name: "Justificatif de taxe d'habitation" },
];

export const subscriptionDocStatus = {
    INEXISTENT: 'inexistent',
    GENERATING: 'generating',
    GENERATED: 'generated',
};

export const ORDER_BY = {
    id: 'id',
    role: 'role',
    email: 'email',
    name: 'name',
    status: 'status',
    lastName: 'lastName',
    firstName: 'firstName',
    login: 'loginDate',
    investmentSum: 'investmentSum',
    createdAt: 'createdAt',
    finishedSubscriptionAt: 'finishedSubscriptionAt',
    subscriptionCreatedAt: 'subscriptionCreatedAt',
    finishedAt: 'finishedAt',
    completedTunnelAt: 'completedTunnelAt',
    shareCategory: 'shareCategory',
    tunnelStep: 'tunnelStep',
    alerts: 'alerts',
    type: 'type',
    closingDate: 'closingDate',
    releaseDate: 'releaseDate',
    commissionControlDate: 'commissionControlDate',
    lastNameAndCompany: 'lastNameAndCompany',
    userRole: 'user.subscriptions.role.name',
    distributorCompanyName: 'distributorCompanyName',
    distributorCompanyStatus: 'distributorCompanyStatus',
    companyStatus: 'companyStatus',
    companyType: 'companyType',
    fundName: 'fundName',
    subject: 'subject',
    distributorFullName: 'distributorFullName',
    transferDate: 'transferDate',
    networkName: 'networkName',
    subscriptionId: 'subscriptionId',
    accountConfirmed: 'accountConfirmed',
};

export const sortDirection = {
    ASC: 'asc',
    DESC: 'desc',
};

export const alertMessagesAdmin = {
    'rib.response.warning': '',
    'rib_check.not_french': texts.RIB_NOT_FRENCH,
    'rib_check.response.iban.not_matching': texts.RIB_IBAN_NOT_MATCHING,
    'rib_check.bic_mismatch': texts.RIB_BIC_NOT_MATCHING,
    'id_check.empty_response': field => texts.EMPTY_RESPONSE(field),
    'id_check.first_name.not_matching': texts.PRENOME_NE_CORRESPOND_ADMIN,
    'id_check.last_name.not_matching': texts.NOME_NE_CORRESPOND_ADMIN,
    'id_check.additional_checks.screening_sanctions': texts.SANCTIONS_ADMIN,
    'id_check.document.invalid': texts.DOCUMENT_PAS_VALIDE,
    'id_document.manual_upload': texts.MANUAL_ID_UPLOAD,
    'id_check.document_type.identical': texts.PREMIER_DOCUMENT_DIFFERENT_ADMIN,
    'id_check_secondary.empty_response': field => texts.EMPTY_RESPONSE(field),
    'id_check.transaction.initiated': texts.VERIFICATION_IDENTITE_ADMIN,
    'id_check_secondary.document_type.identical': texts.SECOND_DOCUMENT_DIFFERENT_ADMIN,
    'id_check_secondary.document.invalid': texts.SECOND_DOCUMENT_INVALID_ADMIN,
    'id_check_secondary.last_name.not_matching': texts.SECOND_DOCUMENT_NOME_ADMIN,
    'id_check_secondary.first_name.not_matching': texts.SECOND_DOCUMENT_PRENOME_ADMIN,
    'id_check_secondary.additional_checks.screening_sanctions': texts.SANCTIONS_ADMIN,
    'id_check_secondary.transaction.initiated': status => {
        if (status === stepStatus.INCOMPLETE) {
            return texts.SECOND_ID_CHECK_INCOMPLETE_ADMIN;
        } else if (status === stepStatus.FAILED) {
            return texts.SECOND_DOCUMENT_INVALID_ADMIN;
        }
        return texts.SECOND_VERIFICATION_IDENTITE_ADMIN;
    },
    'address_check.empty_response': field => texts.EMPTY_RESPONSE(field),
    'address_check.transaction.failed': texts.DOMICILE_PAS_REUSSI_ADMIN,
    'address_check.response.first_name.not_matching':
        texts.PRENOME_NE_CORRESPOND_SOUSCRIPTEUR_ADMIN,
    'address_check.response.last_name.not_matching': texts.NOME_NE_CORRESPOND_SOUSCRIPTEUR_ADMIN,
    'address_check.response.issue_date.older_than': texts.JUSTIFICATIF_DE_DOMICILE_ADMIN,
    'address_check.response.address.postal_code_city_not_matching':
        texts.CODE_POSTAL_NE_CORRESPONDENT_ADMIN,
    'address_check.response.address.street_not_matching': texts.ADRESSE_NE_CORRESPOND_ADMIN,
    'address_check.transaction.initiated': texts.VERIFICATION_DOMICILE_ADMIN,
    'address_check.imprecise_location': texts.ADRESSE_100M,
    'bank_statement_check.transaction.failed': texts.RIB_ECHOUE,
    'bank_statement_check.response.name.not_matching': texts.NOM_EXTRAIT,
    'bank_statement_check.empty_response': field => texts.EMPTY_RESPONSE(field),
    'rib_check.iban.empty_response': field => texts.EMPTY_RESPONSE(field),
    'user_name_updated.redo_id_check': texts.REDO_ID_CHECK_ADMIN,
    'user_name_updated.redo_second_id_check': texts.REDO_SECOND_ID_CHECK_ADMIN,
    'user_address_updated.redo_address_check_after_id_change':
        texts.REDO_ADDRESS_CHECK_AFTER_NAME_CHANGE_ADMIN,
    'user_address_updated.redo_address_check_after_address_change':
        texts.REDO_ADDRESS_CHECK_AFTER_ADDRESS_CHANGE_ADMIN,
    'investor_company.activity.other': texts.OTHER_ACTIVITY,
    'investor_company.corporate_form.other': texts.OTHER_CORPORATE_FORM,
    'investor_company.currency.other_than': texts.OTHER_CURRENCY,
    'investor_company.not_own_account': texts.OTHER_BENEFICIARY,
    'contact_info.financial_residence_outside_fr': texts.RESIDENCE_OUTSIDE_FRANCE,
    'contact_info.co_subscriber.financial_residence_outside_fr':
        texts.RESIDENCE_OUTSIDE_FRANCE_CO_SUBSCRIBER,
    'contact_info.us_person': texts.US_PERSON_ALERT,
    'contact_info.co_subscriber.us_person': texts.US_PERSON_ALERT,
    'contact_info.empty_nif': texts.NUMERO_FISCAL_SAISI,
    'contact_info.co_subscriber.empty_nif': texts.CO_SUBSCRIBER_NUMERO_FISCAL_SAISI,
    'contact_info.nif.empty': texts.NUMERO_FISCAL_SAISI,
    'contact_info.foreign_country_nif.empty': texts.FOREIGN_COUNTRY_NIF_EMPTY,
    'contact_info.co_subscriber.foreign_country_nif.empty':
        texts.FOREIGN_COUNTRY_CO_SUBSCRIBER_NIF_EMPTY,
    'contact_info.us_tax_residency': texts.US_TAX_RESIDENCY,
    'contact_info.co_subscriber.us_tax_residency': texts.US_TAX_RESIDENCY_CO_SUBSCRIBER,
    'contact_info.tin.empty': texts.TIN_EMPTY,
    'contact_info.co_subscriber.tin.empty': texts.TIN_EMPTY_CO_SUBSCRIBER,
    'contact_info.tin.invalid': texts.TIN_INVALID,
    'contact_info.with_co_subscriber': texts.WITH_CO_SUBSCRIBER,
    'comply_advantage.search_investor': texts.PEP_COMPLY_ADVANTAGE_ALERT,
    'comply_advantage.search_co_subscriber': texts.PEP_COMPLY_ADVANTAGE_ALERT_CO_SUBSCRIBER,
    'comply_advantage.search_beneficiaries': texts.PEP_COMPLY_ADVANTAGE_ALERT_BENEFICIAIRE,
    'distributor_company.corporate_form.other': texts.OTHER_CORPORATE_FORM,

    'eligibility.transactions_completed_number.documents': texts.ELIGIBILITY_TRANSACTION_DOCUMENTS,
    'eligibility.portfolio_value.documents': texts.ELIGIBILITY_PORTOFOLIO_DOCUMENTS,
    'eligibility.professional_position.documents': texts.ELIGIBILITY_PRO_DOCUMENTS,
    'experience.fcpr.scoring': texts.COMPREHENSION_DU_PRODUIT,

    'kyc.income.other': texts.OTHER_INCOME,
    'kyc.pep': texts.PEP_ALERT,
    'kyc.co_subscriber.pep': texts.PEP_CO_SUBSCRIBER_ALERT,
    'kyc.heritage.less_than_investing_sum': texts.HERITAGE_LESS_THAN_INVESTMENT,
    'kyc.income.less_than_ten_percent': texts.INCOME_LESS_THAN_10,
    'kyc.financial.instrument.none': texts.NO_FINANCIAL_INSTRUMENT,
    'kyc.heritage.less_than_double_of_investing_sum': texts.SOUSCRIPTION_DEPASSE,
    'kyc.income.movable': texts.MOVABLE_INCOME,
    'kyc.income.real_estate': texts.REAL_ESTATE_INCOME,
    'kyc.heritage.greater_than_fifteen_percent_of_investing_sum': isRolePP =>
        texts.HERITAGE_GREATER_15_PERCENT(isRolePP),
    'kyc.indebtedness_heritage_ratio': isRolePP => texts.INDEBTEDNESS_HERITAGE_RATIO(isRolePP),
    'kyc.other_expenses': texts.OTHER_EXPENSES,
    'user_adequacy.no_income_risk': texts.NO_INCOME_RISK,
    'user_adequacy.objectives_not_synced_with_investment': texts.OBJECTIVES_NOT_SYNCED,
    'user_adequacy.lose_all_funds_effect': texts.FUNDS_LOSS_EFFECT,
    'user_knowledge.scores.weak': texts.USER_KNOWLEDGE_WEAK_SCORES,
    'user_knowledge.slp.level1.score': texts.USER_KNOWLEDGE_SLP_LEVEL1_SCORE,
    'user_knowledge.slp.level2.score': texts.USER_KNOWLEDGE_SLP_LEVEL2_SCORE,
    'user_knowledge.knowledge_origin': answer => texts.USER_KNOWLEDGE_ORIGIN(answer),
    'id_check.expired': texts.ID_EXPIRED,
    'id_check_secondary.expired': texts.SECOND_ID_EXPIRED,
    'user_address_updated.affidavit_uploaded': texts.AFFIDAVIT_UPLOADED,
    'user_address_updated.redo_direct_debit_authorisation':
        texts.REDO_DIRECT_DEBIT_AUTHORISATION_ADDRESS,
    'user_name_updated.redo_direct_debit_authorisation': texts.REDO_DIRECT_DEBIT_AUTHORISATION_NAME,
    'rib_updated.redo_direct_debit_authorisation': texts.REDO_DIRECT_DEBIT_AUTHORISATION_RIB,
    'laundering.investor_vigilance.unlisted_fintech': texts.UNLISTED_FINTECH,
    'laundering.investor_vigilance.listed_company': texts.LISTED_COMPANY,
    'laundering.investor_vigilance.public_authority': texts.PUBLIC_AUTHORITY,
    'laundering.beneficiary_vigilance.listed_company': texts.BENEFICIARY_LISTED_COMPANY,
    'laundering.beneficiary_vigilance.public_authority': texts.BENEFICIARY_PUBLIC_AUTHORITY,
    ABANDONED_STEP: stepId =>
        stepId === stepIDs.CONTACT_INFO
            ? `Abandon sur l'étape "${stepNames[stepId]}" pour raison US person`
            : `Abandon sur l'étape "${stepNames[stepId]}"`,
    'investor_quality.minimum_sum_threshold_choice': texts.SOUSCRIPTION_INITIALE,
    'investor_qualification.funds_origin.other': texts.FUNDS_ORIGIN_OTHER,
    'kyc.financial.instrument.score': texts.FINANCIAL_INSRUMENT_SCORE_ALERT,
    'kyc.financial.instrument.other': texts.FINANCIAL_INSRUMENT_SCORE_OTHER,
    'user_knowledge.media_consultation': texts.USER_KNOWLEDGE_MEDIA_CONSULTATION,
    'user_knowledge.level_warning': texts.USER_KNOWLEDGE_LEVEL_WARNING,
    'result_of_surveys.transactions_completed_number.documents':
        texts.SURVEY_RESULTS_WARNING_TRANSACTION_COMPLETED_NO_DOC,
    'result_of_surveys.portfolio_value.documents':
        texts.SURVEY_RESULTS_WARNING_PORTFOLIO_VALUE_NO_DOC,
    'result_of_surveys.professional_position.documents':
        texts.SURVEY_RESULTS_WARNING_PROFESSIONAL_POSITION_NO_DOC,
    'kyc.asset_percentage': texts.KYC_ASSETS_PERCENTAGE_WARNING,
    'associate_identify.uploaded': texts.ASSOCIATE_IDENTIFY_WARNING,
    'director_identify.uploaded': texts.DIRECTOR_IDENTIFY_WARNING,
    'administrator_identify.uploaded': texts.ADMINISTRATOR_IDENTIFY_WARNING,
    'beneficiary_identify.uploaded': texts.BENEFICIARY_IDENTIFY_WARNING,
    'fatca_document.uploaded': texts.FATCA_DOC_WARNING,
    'laundering.beneficiary_vigilance.empty_nif': name => texts.BENEFICIARY_NIF_WARNING(name),
    'investment.balance_sheet_total': texts.ELIGIBILITY_BALANCE_SHEET_TOTAL_DOC_WARNING,
    'investment.net_sales_or_revenues': texts.ELIGIBILITY_NET_SALES_REVENUE_DOC_WARNING,
    'investment.higher_equity': texts.ELIGIBILITY_HIGHER_EQUITY_DOC_WARNING,
    'kyc.no.carried.out.transactions': texts.KYC_NO_CARRIED_OUT_TRANSACTIONS_WARNING,
    'kyc.investments.management.with.advisor': texts.KYC_INVESTMENT_MGMT_WITH_ADVISOR,
    'kyc.investments.management.by.delegation': texts.KYC_INVESTMENT_MGMT_BY_DELEGATION,
    'kyc.financial_instruments_inexperienced': texts.KYC_INSTRUMENTS_INEXPERIENCED,
    'kyc.no_financial_investments': texts.KYC_NO_INVESTMENTS,
    'investment.association_type': texts.ELIGIBILITY_ASSOCIATION_TYPE_WARNING,
    'kyc.financial_instruments.unlisted_share': texts.NO_UNLISTED_SHARES,
    'kyc.financial_instruments.other_fund': texts.NO_PRIVATE_EQUITY_INVESTMENTS,
    'rib.response.dd_account': texts.IBAN_PROBLEM_DETECTED,
};

export const completedFormTexts = {
    form_0: {
        Oui: (
            <span>
                L'investissement envisagé dans le fonds <strong>représente plus de 10%</strong> de
                votre revenu moyen net ou de votre patrimoine financier.
            </span>
        ),

        Non: (
            <span>
                L'investissement envisagé dans le fonds{' '}
                <strong>ne représente pas plus de 10%</strong> de votre revenu moyen net ou de votre
                patrimoine financier.
            </span>
        ),
    },
    form_1: {
        title: 'Vos revenus principaux :',
        choice: {
            'step5.question_2.option_1': 'Salaire',
            'step5.question_2.option_2': 'Retraite',
            'step5.question_2.option_3': 'Pension alimentaire',
            'step5.question_2.option_4': "Pension d'invalidité",
            'step5.question_2.option_5': 'Revenus mobiliers',
            'step5.question_2.option_6': 'Revenus immobiliers',
            'general_options.other': 'Autre',
        },
    },
    form_2: {
        title: roleName =>
            roleName === RoleNames.PM_PROFESSIONNEL
                ? 'Vous estimez vos actifs à'
                : 'Vous estimez votre patrimoine global à',
    },
    form_3: {
        'step5.question_5.option_1': (
            <span>
                Vous disposez de <strong>moins de 5% </strong>de parts de Fonds de Capital
                Investissement français ou équivalent étranger.
            </span>
        ),
        'step5.question_5.option_2': (
            <span>
                Vous disposez entre <strong>5% et 10% </strong>de parts de Fonds de Capital
                Investissement français ou équivalent étranger.
            </span>
        ),
        'step5.question_5.option_3': (
            <span>
                Vous disposez de <strong>plus de 10% </strong>de parts de Fonds de Capital
                Investissement français ou équivalent étranger.
            </span>
        ),
        noChoice: (
            <span>
                Vous ne disposez pas de parts de Fonds de Capital Investissement français ou
                équivalent étranger.
            </span>
        ),
    },
    form_4: {
        title: 'Vous détenez ou avez détenu :',
        choice: {
            'step5.question_6.option_1': 'OPCVM/FIA actions',
            'step5.question_6.option_2': 'OPCVM/FIA obligations',
            'step5.question_6.option_3': 'OPCVM/FIA monétaires',
            'step5.question_6.option_4': 'Actions cotées',
            'step5.question_6.option_5': 'Actions non cotées',
            'step5.question_6.option_6':
                'Parts de Fonds de Capital Investissement (FCPR / FPS / FPCI/ FCPI/ FIP / équivalent étranger)',
            'step36.question_1.option_1': 'OPCVM',
            'step36.question_1.option_2': 'OPCVM/FIA actions',
            'step36.question_1.option_3': 'OPCVM/FIA obligations',
            'step36.question_1.option_4': 'OPCVM/FIA monétaires',
            'step36.question_1.option_5': 'Actions cotées',
            'step36.question_1.option_6': 'Actions non cotées',
            'step36.question_1.option_7':
                'Parts de Fonds de Capital Investissement (FCPR / FPS / FPCI/ FCPI/ FIP / équivalent étranger)',
            'general_options.none': 'Aucun instrument financier',
            'general_options.other': 'Autre instrument financier',
        },
    },
    form_5: {
        title: 'Au cours des 12 derniers mois, vous avez investi dans',
        choice: {
            opcvmActionInvestment: 'OPCVM/FIA actions',
            opcvmObligationInvestment: 'OPCVM/FIA obligations',
            opcvmMonetaryInvestment: 'OPCVM/FIA monétaires',
            listedShareInvestment: 'Actions cotées',
            unlistedShareInvestment: 'Actions non cotées',
            otherFundInvestment: 'Parts de FCPR/FPS/FPCI',
            otherInvestment: 'Autres',
        },
        noChoice:
            "Au cours des 12 derniers mois, vous n'avez investi dans aucun instrument financier.",
    },
    form_6: {
        title: 'Le mode de gestion des actifs financier est :',
        choice: {
            'step31.group_1.option_1': 'Gestion interne',
            'step31.group_1.option_2':
                "Avec recours aux conseils d'un établissement tiers habilité",
            'step31.group_1.option_3': 'Par mandat(s) confié(s) à un/des gérant(s)',
            'step31.group_1.option_4': 'Mixte',
            'step31.group_1.option_5':
                'Par externalisation (couvertures de passifs sociaux, épargne salariale, autre)',
        },
    },
    form_7: {
        Oui: texts.HAS_PROFESSIONAL_POSITION,
        Non: texts.MISSING_PROFESSIONAL_POSITION,
    },
    form_36: {
        title: texts.INVESTMENT_EXPERIENCE,
        choice: {
            'step36.question_2.option_1': 'géré directement vos avoirs',
            'step36.question_2.option_2': "géré vos avoirs avec l'aide d'un conseiller",
            'step36.question_2.option_3':
                "géré vos avoirs par délégation, dans le cadre d'un mandat de gestion",
            'step36.question_2.option_4':
                "subi une perte en capital latente d'au moins 20 % de votre investissement initial",
        },
        noChoice:
            "Dans le cadre de vos investissements financiers, vous n'avez rien géré et vous n'avez pas subi des pertes.",
    },
    debtForm: {
        title: 'Vous estimez votre endettement total à',
        alternateTitle: 'Vous estimez votre passif à',
    },
    otherExpensesForm: {
        Oui: "Vous avez d'autres charges : ",
        Non: "Vous n'avez pas d'autres charges.",
    },
    balanceLevel: {
        title: 'Le niveau total de votre bilan est : ',
    },
    turnoverLevel: {
        title: "Le niveau total de votre chiffre d'affaires est : ",
    },
    totalEquity: {
        title: 'Le niveau total des capitaux propres est : ',
    },
};

export const question3IneligibleMessage = (
    <React.Fragment>
        {texts.ELIGIBILITY_CONTACT_SGP_INFO}{' '}
        <Link underline="hover" href="mailto:contact@petech.fr">
            contact@petech.fr
        </Link>
        {'.'}
    </React.Fragment>
);

export const getProClientOptions = excludeNr16 =>
    Array.from({ length: 15 }, (v, k) => k + 1)
        .map(index => `step34_fpci_pm_real.question_${index}`)
        .concat(excludeNr16 ? [] : 'step34_fpci_pm_real.question_16.label');

export const skippableStepsForProClient = [
    stepIDs.USER_KNOWLEDGE,
    stepIDs.EXPERIENCE,
    stepIDs.USER_ADEQUACY,
    stepIDs.KYC_SURVEY,
    stepIDs.PREFERENCES,
    stepIDs.SURVEY_RESULTS,
];

export const PM_DOCUMENTS_LIST = [
    texts.KBIS_A_JOUR,
    texts.STATUTS_A_JOUR,
    texts.DOCUMENTS_DE_IDENTITE,
    texts.RIB_DOC,
    texts.LISTE_DES_BENEFICIAIRES,
    texts.DOCUMENTS_DE_IDENTITE_DES_BENEFICIAIRES,
    texts.AUTO_CERTIFICATION_FATCA,
    texts.JUSTIFICATIF_DE_DOMICILE_REPRESENTANT_LEGAL,
];

export const PP_DOCUMENTS_LIST = [
    texts.DEUX_JUSTIFICATIFS,
    texts.JUSTIFICATIF_DE_DOMICILE_DE_MOINS,
    texts.VOS_COORDONNEES_BANCAIRES,
];

export const investmentMapping = {
    tier1: [
        'step34_fpci_pm_real.question_1',
        'step34_fpci_pm_real.question_2',
        'step34_fpci_pm_real.question_3',
        'step34_fpci_pm_real.question_4',
        'step34_fpci_pm_real.question_5',
        'step34_fpci_pm_real.question_6',
        'step34_fpci_pm_real.question_7',
        'step34_fpci_pm_real.question_8',
        'step34_fpci_pm_real.question_9',
        'step34_fpci_pm_real.question_10',
        'step34_fpci_pm_real.question_11',
        'step34_fpci_pm_real.question_12',
        'step34_fpci_pm_real.question_13',
        'step34_fpci_pm_real.question_14',
        'step34_fpci_pm_real.question_15',
        'step34_fpci_pm_real.question_16.label',
        'step34_fpci_pm_real.question_18.option_1.label',
        'step34_fpci_pm_real.question_18.option_2.label',
        'step34_fpci_pm_real.question_18.option_3.label',
        'step34.question_2.option_1',
        'step34.question_2.option_2',
        'step34.question_2.option_3',
        'step34_fcpr_pp_real.question_1',
        'step34_fcpr_pp_real.question_2',
    ],
    tier2: ['step34_fpci_pm_real.question_17', 'step34.question_1.label'],
};

export const exceptionTierOptions = [
    'step34_fpci_pm_real.question_18.option_1.label',
    'step34_fpci_pm_real.question_18.option_2.label',
    'step34_fpci_pm_real.question_18.option_3.label',
    'step34.question_2.option_1',
    'step34.question_2.option_2',
    'step34.question_2.option_3',
];

export const paymentMethods = {
    DIRECT_DEBIT: 'direct_debit',
    CREDIT_TRANSFER: 'credit_transfer',
};

export const quillFormats = [
    'background',
    'bold',
    'color',
    'font',
    'code',
    'italic',
    'link',
    'size',
    'strike',
    'script',
    'underline',
    'blockquote',
    'header',
    'indent',
    'list',
    'align',
    'direction',
    'code-block',
    'formula',
    // 'image',
    // 'video'
];

export const paymentEnrichments = {
    INVESTMENT_FUND: 'investmentFund',
    SUBSCRIPTIONS: 'subscriptions',
    SHARE_SUBCATEGORY: 'shareSubcategory',
    CLOSING: 'closing',
};

export const environments = {
    PROD: 'prod',
    PREPROD: 'preprod',
    TEST: 'testing',
    LOCAL: 'local',
};

export const docTypes = {
    ADA: 'ADA',
    ADMINISTRATORS_IDENTIFICATION: 'ADMINISTRATORS_IDENTIFICATION',
    AFFIDAVIT: 'AFFIDAVIT',
    ASSOCIATES_IDENTIFICATION: 'ASSOCIATES_IDENTIFICATION',
    AUTORISATION_DE_PRELEVEMENT: 'AUTORISATION_DE_PRELEVEMENT',
    AUTORISATION_DE_PRELEVEMENT_DISABLED: 'AUTORISATION_DE_PRELEVEMENT_DISABLED',
    BENEFICIARY_DOCUMENT: 'BENEFICIARY_DOCUMENT',
    BENEFICIARY_IDENTIFICATION: 'BENEFICIARY_IDENTIFICATION',
    BENEFICIARY_REDUCED_VIGILANCE: 'BENEFICIARY_REDUCED_VIGILANCE',
    BLANCHIMENT: 'BLANCHIMENT',
    SUBSCRIPTION_FORM: 'BULLETIN_DE_SOUSCRIPTION',
    SUBSCRIPTION_FORM_DEPRECATED: 'BULLETIN DE SOUSCRIPTION',
    CIF: 'CIF',
    COMPANY: 'COMPANY',
    SGP: 'SGP',
    DIRECTORS_IDENTIFICATION: 'DIRECTORS_IDENTIFICATION',
    FACTURE: 'FACTURE',
    DISTRIBUTOR_BILL: 'DISTRIBUTOR_BILL',
    DISTRIBUTOR_BILL_EXCEL: 'DISTRIBUTOR_BILL_EXCEL',
    FATCA: 'FATCA',
    ID: 'ID',
    DRIVING_LICENSE: 'DRIVING_LICENSE',
    INVESTOR_REDUCED_VIGILANCE: 'INVESTOR_REDUCED_VIGILANCE',
    KBIS: 'KBIS',
    MARKETERS: 'MARKETERS',
    OTHER: 'OTHER_DOCUMENT',
    POUVOIR: 'POUVOIR',
    RIB: 'RIB',
    SECONDARY_ID: 'SECONDARY_ID',
    SEPA: 'SEPA',
    STATUTES: 'STATUTES',
    CAPITAL_CALL: 'APPEL_DE_FOND',
    CLOSING: 'CLOSING',
    CAPITAL_ACCOUNT: 'CAPITAL_ACCOUNT',
    REPORTING: 'REPORTING',
    TAX_EXEMPTION: 'TAX_EXEMPTION',
    INVESTMENT_FUND: 'INVESTMENT_FUND',
    INVESTOR_CLASSIFICATION: 'INVESTOR_CLASSIFICATION',
    DOCUMENT_SUBTYPE_PROFESSIONAL_POSITION_HELD: 'PROFESSIONAL_POSITION_HELD',
    DOCUMENT_SUBTYPE_PORTFOLIO_VALUE: 'PORTFOLIO_VALUE',
    DOCUMENT_SUBTYPE_TRANSACTIONS_COMPLETED: 'TRANSACTIONS_COMPLETED',
    PROMOTER: 'PROMOTER',
    NAV: 'NAV',
};

export const COMPANY_AUDIT_DOCUMENTS_SUBTYPES = [
    'legalRepresentantAuthority',
    'oriasAttestation',
    'criminalRecordExtract',
    'beneficiariesRegister',
    'beneficiariesIdentityDocuments',
    'legalRepresentativesIdentityDocuments',
    'kbis',
    'insuranceCertificate',
    'signatoryId',
    'legalRepresentantId',
];

export const COMPANY_DOCUMENTS = [
    // companyLogo is also a company document but it's not necessary in this list
    'legalRepresentativeDocument',
    'certificateORIAS',
    'legalRepresentativeCriminalRecord',
    'beneficiariesRegister',
    'beneficiariesIdentityDocuments',
    'legalRepresentativesIdentityDocuments',
    'kbis',
    'insuranceCertificate',
    'legalRepresentativeIdentityDocument',
    'signatoryIdentityDocument',
];

export const APPROVABLE_DOCUMENTS = [
    'certificateORIAS',
    'legalRepresentativeCriminalRecord',
    'beneficiariesRegister',
    'beneficiariesIdentityDocuments',
    'legalRepresentativesIdentityDocuments',
    'insuranceCertificate',
    'kbis',
    'rib',
    'signatoryIdentityDocument',
    docTypes.COMPANY,
    docTypes.RIB,
    docTypes.OTHER,
];

export const REPLACEABLE_INVESTOR_RELATED_DOCUMENTS = [
    'ID',
    'SECONDARY_ID',
    'FACTURE',
    'AFFIDAVIT',
    'KBIS',
    'STATUTES',
    'BLANCHIMENT',
    'INVESTOR_REDUCED_VIGILANCE',
    'BENEFICIARY_REDUCED_VIGILANCE',
    'BENEFICIARY_DOCUMENT',
    'OTHER_DOCUMENT',
];

export const INVESTOR_RELATED_DOCUMENTS = [
    ...REPLACEABLE_INVESTOR_RELATED_DOCUMENTS,
    'BENEFICIARY_IDENTIFICATION',
    'ADMINISTRATORS_IDENTIFICATION',
    'DIRECTORS_IDENTIFICATION',
    'ASSOCIATES_IDENTIFICATION',
    'FATCA',
];

export const PROFESSIONAL_CLIENT_DOCUMENTS = [
    docTypes.DOCUMENT_SUBTYPE_PROFESSIONAL_POSITION_HELD,
    docTypes.DOCUMENT_SUBTYPE_PORTFOLIO_VALUE,
    docTypes.DOCUMENT_SUBTYPE_TRANSACTIONS_COMPLETED,
];

export const INVESTOR_DOCUMENTS_TO_ARCHIVE = [
    ...INVESTOR_RELATED_DOCUMENTS,
    ...PROFESSIONAL_CLIENT_DOCUMENTS,
].filter(t => t !== 'OTHER_DOCUMENT');

export const EMAIL_VALIDATION_OPTIONS = { minDomainSegments: 2, tlds: { allow: false } };

export const distributorType = {
    GROUPEMENT: 'group',
    STANDARD: 'standard',
};

export const idDocs = [
    { value: 'ID_CARD', label: texts.ID_CARD_TWO_SIDED },
    { value: 'PASSPORT', label: texts.PASSPORT_WITH_SIGNATURE },
    { value: 'OTHER', label: texts.AUTRE },
];

export const emailAvailabilityStatus = {
    AVAILABLE: 'email_available', // the email is not found in the DB
    NOT_INVESTOR: 'user_not_investor', // the user is not investor
    WITH_ONGOING_SUBSCRIPTION: 'investor_has_ongoing_subscription', // the investor has ongoing subscription
    WITH_FINISHED_SUBSCRIPTION: 'investor_has_finished_subscription', // the investor has only finished subscriptions
};

export const investorClassificationKeys = {
    PRO: 'professional',
    NON_PRO: 'non_professional',
};

export const investorClassifications = {
    [investorClassificationKeys.PRO]: texts.PRO_CLIENT,
    [investorClassificationKeys.NON_PRO]: texts.NON_PRO_CLIENT,
};

export const signatoryUserType = {
    SUBSCRIBER: 'subscriber',
    CO_SUBSCRIBER: 'co_subscriber',
    SERVICER: 'sgp_signataire',
};

export const closingPremium = {
    WITHOUT_PREMIUM: 'without_premium',
    WITH_PREMIUM: 'with_premium',
};

export const listingActionButtonStyle = theme => ({
    color: theme.palette.common.primaryAlt,
    padding: '6px 8px',
    fontSize: '13px',
    '&:hover': { backgroundColor: 'inherit' },
});

export const bankingStatementStatus = {
    PENDING_VERIFICATION: 'pending_verification', // checking with jumio
    PENDING_VALIDATION: 'pending_servicer_validation', // Servicer user validation
    PENDING_SIGNATURE: 'pending_ap_signature', // Servicer user validation
    OK: 'ok',
};

export const inviteFormType = {
    CIF: 'cif',
    PROVIDER: 'provider',
    SERVICER: 'servicer',
    PROMOTER: 'promoter',
};

export const questionType = {
    TEXT: 'fields',
    RADIO: 'radio-buttons',
    CHECKBOX: 'checkboxes',
};

export const alertType = { WARNING: 'warning', CRITICAL: 'critical', OK: 'ok' };

export const conditionType = {
    LESS_THAN: 'is_less_than',
    GREATER_THAN: 'is_greater_than',
    EQUAL: 'is_equal_to',
};

export const entityKey = {
    DOCUMENT: 'documents',
    INVESTMENT_FUND: 'investment_funds',
    TUNNEL: 'tunnels',
    TUNNEL_ACTION: 'tunnel_actions',
    QUESTION: 'questions',
    CATEGORY: 'share_categories',
    SUBCATEGORY: 'share_subcategories',
};

export const tunnelPaths = [
    '/onboarding/:stepId',
    '/onboarding',
    '/sign-up/:stepId/:tsId',
    '/sign-up/:stepId',
    '/sign-up',
    '/new-subscription/:stepId/:tsId',
    '/new-subscription/:stepId',
    '/new-subscription',
    '/create-subscription',
    '/create-subscription/:stepId',
];

export const bicValidationMessages = {
    'string.empty': texts.SAISIR_LE_CHAMP,
    'string.pattern': texts.CODE_BIC_INVALID_CHARACTERS,
    'string.length': texts.BIC_FORMAT_CONTENT,
};
